
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/material/examples/code-block",
      function () {
        return require("private-next-pages/x/react-chat/material/examples/code-block.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/material/examples/code-block"])
      });
    }
  